import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

import { ToastrService } from '@shared/services/toastr.service';
import { EventTypes } from '@shared/services/organization-journal.service';
import { FeatureFlagService } from '@shared/services/feature-flag.service';
import { LabelComponent } from '@shared/components/label/label.component';
import { SwitchComponent } from '@shared/components/switch/switch.component';
import { FormsModule } from '@angular/forms';
import { NgFor } from '@angular/common';

@Component({
  selector: 'app-my-notifications',
  templateUrl: './my-notifications.component.html',
  styleUrls: ['./my-notifications.component.scss'],
  imports: [LabelComponent, SwitchComponent, FormsModule, NgFor, TranslatePipe],
})
export class MyNotificationsComponent implements OnInit {
  notifications = {
    monthlyReport: false,
    eventNotificationMinSeverities: {
      SECURITY: null,
      MONITORING: null,
      ACTIVITY: null,
    },
  };

  constructor(
    private http: HttpClient,
    private translate: TranslateService,
    private toastr: ToastrService,
    private featureFlagService: FeatureFlagService,
  ) {}

  protected readonly EventTypes = EventTypes;

  ngOnInit() {
    this.getNotifications();
  }

  getNotifications() {
    this.http.post('notifications/get', {}).subscribe((res: any) => {
      if (!res.hasError) {
        this.notifications.monthlyReport = res.items[0].monthlyReport || false;
        this.notifications.eventNotificationMinSeverities = res.items[0].eventNotificationMinSeverities;
      }
    });
  }

  changeNotification(notification, event) {
    const data = {
      data: {},
    };

    data.data[notification] = event;

    this.http.post('notifications/update', data).subscribe((res: any) => {
      if (!res.hasError) {
        this.toastr.success();
      }
    });
  }

  changeEventNotification(eventType, value) {
    const data = {
      data: { eventNotificationMinSeverities: { [eventType]: this.handleNull(value) } },
    };

    this.http.post('notifications/update', data).subscribe((res: any) => {
      if (!res.hasError) {
        this.toastr.success();
      }
    });
  }

  handleNull(value: any) {
    return value === 'null' ? null : value;
  }
}
